import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tag',
  templateUrl: 'tag.component.html',
  styleUrls: ['./tag.component.less', '../../../../shared/common.less'],
})

export class TagComponent implements OnInit {
  @Input() isValidated: boolean = false;
  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
